module.exports = __webpack_public_path__ + "img/henganLogo.06206015.png";